const Bike = ({props}) => (
  <svg
    fill="#ffffff"
    stroke="#ffffff"
    height="30px"
    width="30px"
    viewBox="0 0 297.438 297.438"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path d="M292.064,15.365c-4.173-1.45-8.732,0.754-10.184,4.928c-4.368,12.557-19.12,14.583-52.722,14.583c-4.418,0-8,3.582-8,8
        c0,4.418,3.582,8,8,8c4.42,0,8.862-0.001,13.25-0.091l-25.333,104.011l-9.398-1.143c-3.962-0.484-7.575,1.724-8.607,5.561
        c-0.244,0.65-2.049,5.036-7.823,9.495c-8.486,6.553-21.484,10.017-37.588,10.017c-16.662,0-29.906-8.764-43.928-18.042
        c-14.095-9.327-28.67-18.972-46.896-18.972c-1.458,0-2.913,0.269-4.369,0.391L44.361,84.518H59c4.418,0,8-3.582,8-8
        c0-4.418-3.582-8-8-8H9c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8h18.893l14.993,61.227c-2.772,1.056-5.568,2.227-8.404,3.73
        c-14.146,7.5-23.363,20.308-26.655,37.133c-2.611,13.351-1.357,29.026,3.53,43.82c4.825,14.606,11.521,27.09,16.863,36.09H8
        c-4.418,0-8,3.582-8,8s3.582,8,8,8h242c4.418,0,8-3.582,8-8s-3.582-8-8-8h-20.623l22.444-98.405c0.505-2.209,0.05-4.628-1.254-6.481
        c-1.303-1.854-3.33-3.119-5.579-3.393l-11.919-1.474l26.052-106.978c17.507-2.025,32.153-7.798,37.87-24.233
        C298.443,21.382,296.237,16.816,292.064,15.365z M209.255,222.213l-23.734,7.567c0.008,0.27,0.062,0.541,0.062,0.813
        c0,16.261-13.164,29.45-29.429,29.45c-16.263,0-29.439-13.189-29.439-29.45c0-16.263,13.192-29.449,29.454-29.449
        c10.326,0,19.241,5.319,24.499,13.362l17.998-5.77v-9.618c0-4.418,3.582-8,8-8c4.418,0,8,3.582,8,8v15.471
        C214.667,218.074,212.578,221.158,209.255,222.213z"/>
    </g>
  </svg>
);

export default Bike;
